<div class="modal-title">Rename category</div>

<div class="content">
    <input placeholder="Enter a name" [(ngModel)]="category.name">
</div>

<a-button width="100%" type="secondary" label="Confirm" (onClick)="confirmName()"></a-button>